// Created removeTranscriptAnnotation in order to remove transcript on mobile devices for Lite users
export const removeTranscriptAnnotation = (config) => {
    const {annotations } = config
    const removeSmartCaptions = annotations.filter(a => a.type !== 'smartcaptions');
    return {
        ...config,
        annotations: config?.context?.user?.permissions?.showVeil ? removeSmartCaptions : annotations
    }
}